module.exports = __webpack_public_path__ + "media/images/views/lp/about-us/info-630ab80333a6ed008ded78defd39aaac.jpg";